import React, { useState } from "react";
import { motion } from "framer-motion";
import "./membership.css";

function MembershipDirectory() {
  // -----------------------------------------
  // MEMBERS STATE
  // -----------------------------------------
  const [members, setMembers] = useState([

            {
         id: 20,
      name: "Eye Care Clinic & Optical",
      location: "Colombo 08",
      phone: "+94112682277", 
      googleMap: "https://share.google/nuYSdVZ3bIMFjUPj8",
      images: [
        "/shops/eye care/1.jpeg",
        "/shops/eye care/2.jpeg",
        "/shops/eye care/3.jpeg",
        "/shops/eye care/4.jpeg",
        "/shops/eye care/5.jpeg",
    
      ],
      currentIndex: 0,
    },

    {
      id: 1,
      name: "Wijesundara Optometrist",
      location: "Kuruwita",
      phone: "+94779544263", 
      googleMap: "https://share.google/m0bP9Pk9mqVgqU0Qh",
      images: [
        "/shops/BLGR-WIJESUNDARA/1.jpg",
        "/shops/BLGR-WIJESUNDARA/2.jpg",
      ],
      currentIndex: 0,
    },
    {
      id: 2,
      name: "Family Vision Center",
      location: "Kottawa",
      phone: "+94774412388", 
      googleMap: "https://maps.app.goo.gl/Q6MGxAutDgqubwYS6",
      images: [
        "/shops/DharshiLekha/1.jpeg",
        "/shops/DharshiLekha/2.jpeg",
      ],
      currentIndex: 0,
    },
    {
      id: 3,
      name: "Gamage Opticals Pvt Ltd",
      location: "Nawalapitiya",
      phone: "+94542222959", 
      googleMap: "https://maps.app.goo.gl/fCuiKwWM3wD5k1uL6?g_st=iw",
      images: [
        "/shops/DilrukshiGamage/1.jpeg",
        "/shops/DilrukshiGamage/2.jpeg",
      ],
      currentIndex: 0,
    },
    {
      id: 4,
      name: "Deneth Opticians",
      location: "Avissawella",
      phone: "+94761017763", 
      googleMap: "https://share.google/3ReLp6R5dohCoj0jQ",
      images: [
        "/shops/DilshaniSamudika/1.jpg",
        "/shops/DilshaniSamudika/2.jpg",
        "/shops/DilshaniSamudika/3.jpg",
        "/shops/DilshaniSamudika/4.jpg",
      ],
      currentIndex: 0,
    },
    {
      id: 5,
      name: "Anura Opticians",
      location: "Panadura",
      phone: "+94382231969", 
      googleMap: "https://maps.app.goo.gl/N6HP7Tnaxh2PkEUo9",
      images: [
        "/shops/AnuraPerera/2.jpg",
        "/shops/AnuraPerera/1.jpg",
      ],
      currentIndex: 0,
    },
    {
      id: 6,
      name: "Ganeesha Optical",
      location: "Tangalle",
      phone: "", 
      googleMap: "https://share.google/D2U992QvK5ktzqNF8",
      images: [
        "/shops/GGMadushani/1.jpg",
        "/shops/GGMadushani/2.jpg",
        "/shops/GGMadushani/3.jpg",
        "/shops/GGMadushani/4.jpg",
        "/shops/GGMadushani/5.jpg",
      ],
      currentIndex: 0,
    },
    {
      id: 7,
      name: "Marasinghe Optician",
      location: "Marawila",
      phone: "+94779573242", 
      googleMap: "https://share.google/BgYiOu1f2yLT1ttmd",
      images: [
        "/shops/Namali/1.jpeg",
        "/shops/Namali/2.jpeg",
        "/shops/Namali/3.jpeg",
        "/shops/Namali/4.jpeg",
        "/shops/Namali/5.jpeg",
        "/shops/Namali/6.jpeg",
        "/shops/Namali/7.jpeg",
      ],
      currentIndex: 0,
    },
    {
      id: 8,
      name: "Nethini Eye Care Pvt Ltd",
      location: "Wattala",
      phone: "+94112948777", 
      googleMap: "https://share.google/TX4a3bX1oq0BXvkfv",
      images: [
        "/shops/PrabhaAPerera/1.jpg",
        "/shops/PrabhaAPerera/2.jpg",
        "/shops/PrabhaAPerera/3.jpg",
      ],
      currentIndex: 0,
    },
        {
      id: 9,
      name: "Vienna Health and Eye Care",
      location: "Ja-Ela",
      phone: "+94114344420", 
      googleMap: "https://share.google/STaSmpt0P6p2DK45D",
      images: [
        "/shops/gomis/1.JPG",
        "/shops/gomis/2.JPG",
        "/shops/gomis/3.JPG",
      ],
      currentIndex: 0,
    },
        {
      id: 10,
      name: "Opasroo Vision Care",
      location: "Kalagedihena",
      phone: "+94715878636", 
      googleMap: "https://maps.app.goo.gl/d6wFv1MBXGPas9hp9",
      images: [
        "/shops/anusha/1.jpg",
        "/shops/anusha/2.jpg",
      ],
      currentIndex: 0,
    },
    {
      id: 11,
      name: "Neth Optometrist and Pharmacy",
      location: "Kolonnawa",
      phone: "+94112532153", 
      googleMap: "https://maps.app.goo.gl/WSw6Qwa3GkC8dKXs8",
      images: [
        "/shops/UdeniGurusinghe/1.jpeg",
        "/shops/UdeniGurusinghe/2.jpeg",
        "/shops/UdeniGurusinghe/3.jpeg",
      
      ],
      currentIndex: 0,
    },

    {
      id: 12,
      name: "Colombo Opticians",
      location: "Colombo 14",
      phone: "+94112335882", 
      googleMap: "https://share.google/iNoir42sk2wkqwgHc",
      images: [
        "/shops/SurangaDeSilva/1.jpg",
        "/shops/SurangaDeSilva/2.jpg",
     
      ],
      currentIndex: 0,
    },
        {
      id: 13,
      name: "Kandy Nisakma Optical",
      location: "Kandy",
      phone: "+94779051085", 
      googleMap: "https://maps.app.goo.gl/iVrMqHqWTKHwZxtE8?g_st=iwb",
      images: [
        "/shops/neil/1.jpeg",
        "/shops/neil/2.jpeg",
        "/shops/neil/3.jpeg",
        "/shops/neil/4.jpeg",
      
      ],
      currentIndex: 0,
    },
            {
      id: 14,
      name: "City optical",
      location: "Kattankudy",
      phone: "+94779583437", 
      googleMap: "https://share.google/WPiI7fNOoFhpFKikc",
      images: [
        "/shops/sameel/1.jpeg",
        "/shops/sameel/2.jpeg",
        "/shops/sameel/3.jpeg",
    
      ],
      currentIndex: 0,
    },
                {
      id: 15,
      name: "Bernard wijethunga opticals & vision center",
      location: "Kadawatha",
      phone: "+94712116930", 
      googleMap: "https://maps.app.goo.gl/EzgbRcZ4NZoaJfjG6",
      images: [
        "/shops/Sujanima/1.jpeg",
        "/shops/Sujanima/2.jpg",
        "/shops/Sujanima/3.jpg",
    
      ],
      currentIndex: 0,
    },

                    {
      id: 16,
      name: "H M S Siriwardhane Optometrists",
      location: "Ja-Ela",
      phone: "+94112229822", 
      googleMap: "https://share.google/u1b5qggWiQII17EG6",
      images: [
        "/shops/prabhamali/1.jpeg",
        "/shops/prabhamali/2.jpeg",
        "/shops/prabhamali/3.jpeg",
         "/shops/prabhamali/4.jpeg",
    
      ],
      currentIndex: 0,
    },


                        {
      id: 17,
      name: "Green Eye Optical & Opticare",
      location: "Katana",
      phone: "+94711200705", 
      googleMap: "https://maps.app.goo.gl/CfpMP3y8seM4JwRo7",
      images: [
        "/shops/Vajira/1.jpeg",
        "/shops/Vajira/3.jpeg",
        "/shops/Vajira/4.jpeg",
        "/shops/Vajira/5.jpeg",
      ],
      currentIndex: 0,
    },

                            {
      id: 18,
      name: "Royal Opticare (Pvt) Ltd",
      location: "Puttalam",
      phone: "+94767780850", 
      googleMap: "https://share.google/fAAg8zxILpID2nL5N",
      images: [
        "/shops/sameerah/1.jpg",
        "/shops/sameerah/2.jpg",
        "/shops/sameerah/3.jpg",
        "/shops/sameerah/4.jpg",
    
      ],
      currentIndex: 0,
    },

          {
         id: 19,
      name: "Vision Eye Care",
      location: "Katubedda",
      phone: "+94717570360", 
      googleMap: "https://maps.app.goo.gl/wXKLUdPiWC1fVtuFA?g_st=ic",
      images: [
        "/shops/lahiru/1.jpeg",
        "/shops/lahiru/2.jpeg",
    
      ],
      currentIndex: 0,
    },

    
            {
         id: 21,
      name: "Sun Optic & Eye Clinic",
      location: "Colombo 10",
      phone: "+94777918989", 
      googleMap: "https://share.google/viXIuHvGBhUUuPcij",
      images: [
        "/shops/sun optic/1.jpg",
        "/shops/sun optic/2.jpg",
        "/shops/sun optic/3.jpg",
        "/shops/sun optic/4.jpg",
        "/shops/sun optic/5.jpg",
    
      ],
      currentIndex: 0,
    },


                {
         id: 22,
      name: "Nawagamuwa Optical Service",
      location: "Minuwangoda",
       phone: "+94112288300", 
      googleMap: "https://maps.app.goo.gl/YcMZYoxtuEuyQggv6",
      images: [
        "/shops/dhanawardane/1.jpg",
        "/shops/dhanawardane/2.jpg",
        "/shops/dhanawardane/3.jpg",
        "/shops/dhanawardane/4.jpg",
     
    
      ],
      currentIndex: 0,
    },


                    {
         id: 23,
      name: "Gampaha Optical Pvt(Ltd)",
      location: "Gampaha",
       phone: "+94775178288", 
      googleMap: "https://share.google/xYN8JHogtexNdmY5b",
      images: [
        "/shops/thalansuriya/1.jpg",
        "/shops/thalansuriya/2.jpg",

     
    
      ],
      currentIndex: 0,
    },


{
  id: 23,
  name: "Vision Concept",
  location: "Dehiwala-Mount Lavinia",
  phone: "+94112765512", 
  googleMap: "https://share.google/SUsUTGxZrIFJ9yJW2",
  images: [
    "/shops/eranda/1.jpeg",
    "/shops/eranda/2.jpeg",
    "/shops/eranda/3.jpeg",
    "/shops/eranda/4.jpeg",
    "/shops/eranda/5.jpeg",
  ],
  currentIndex: 0,
},

{
  id: 24,
  name: "H. M. S. Siriwardhane Optometrists",
  location: "Ratmalana",
  phone: "075 719 8893", 
  googleMap: "",
  images: [
    "/shops/erandi/2.jpeg",
    "/shops/erandi/1.jpeg",
    "/shops/erandi/3.jpeg",
    "/shops/erandi/4.jpeg",
    "/shops/erandi/5.jpeg",

  ],
  currentIndex: 0,
},

{
  id: 25,
  name: "Adil Eye And Vision Center",
  location: "Veyangoda",
  phone: "0333 555 412", 
  googleMap: "https://share.google/jZbj3DlPbvvVxfU2I",
  images: [
    "/shops/sadun/1.jpeg",
    "/shops/sadun/2.jpeg",
    "/shops/sadun/3.jpeg",
    "/shops/sadun/4.jpeg",
    "/shops/sadun/5.jpeg",

  ],
  currentIndex: 0,
},



  ]);

  // -----------------------------------------
  // IMAGE SLIDER FUNCTIONS
  // -----------------------------------------
  const handleNextImage = (index) => {
    setMembers((prev) =>
      prev.map((m, i) =>
        i === index
          ? { ...m, currentIndex: (m.currentIndex + 1) % m.images.length }
          : m
      )
    );
  };

  const handlePrevImage = (index) => {
    setMembers((prev) =>
      prev.map((m, i) =>
        i === index
          ? {
              ...m,
              currentIndex:
                (m.currentIndex - 1 + m.images.length) % m.images.length,
            }
          : m
      )
    );
  };

  // -----------------------------------------
  // JSX RETURN
  // -----------------------------------------
  return (
    <section id="directory" className="section directory">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Members of Optica International
        </motion.h2>

        <p className="section-subtitle">
          Verified members of Optica International Pvt Ltd
        </p>

<div className="directory-grid">
  {members.slice(0, 100).map((member, index) => (
    <motion.div
      className="member-card"
      key={member.id}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      whileHover={{ y: -10 }}
    >
      {/* IMAGE SLIDER */}
      <div className="slider-container">
        <img
          src={member.images[member.currentIndex]}
          alt={member.name}
          className="slider-image"
        />

        <button
          className="slider-arrow left"
          onClick={() => handlePrevImage(index)}
        >
          ❮
        </button>

        <button
          className="slider-arrow right"
          onClick={() => handleNextImage(index)}
        >
          ❯
        </button>
      </div>

      <div className="member-info">
        <h4>{member.name}</h4>
        <a
  href={`tel:${member.phone}`}
  className="btn-call"
>
  {member.phone}
</a>
<br />
        <p className="optical-location">{member.location}</p>

        {/* PHONE NUMBER VISIBLE CTA */}

        {/* LOCATION BUTTON */}
        <a
          href={member.googleMap}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-location"
        >
          Get Location
        </a>
      </div>
    </motion.div>
  ))}
</div>


      </div>
    </section>
  );
}

export default MembershipDirectory;